<template>
    <ModalBase :name="name" :title="title" @close="close()">
        <div class="tw:flex tw:flex-col tw:items-center tw:gap-3 tw:py-2">
            <div class="tw:flex tw:items-center tw:justify-center tw:w-16 tw:h-16 tw:rounded-full tw:bg-red-50">
                <i class="fas fa-trash-alt tw:text-2xl tw:text-red-500"></i>
            </div>

            <div class="tw:flex tw:flex-col tw:items-center tw:gap-1 tw:text-center">
                <h3 class="tw:text-lg tw:font-semibold tw:text-gray-800">{{ borrarTitle }}</h3>
                <slot></slot>
                <p class="tw:text-xl tw:font-semibold tw:text-gray-500 tw:mt-1">{{ confirmButton }}</p>
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2 tw:pt-2">
                <Button variant="ghost" @click="close">Cancelar</Button>
                <Button variant="danger" @click="confirm">SI, BORRAR</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    defineProps({
        name: String,
        title: String,
        borrarTitle: String,
        confirmButton: String
    })

    const emit = defineEmits(['close', 'confirm'])

    const close = () => {
        emit('close')
    }

    const confirm = () => {
        emit('confirm')
    }
</script>
